import { useEffect, useState, useRef } from "react";
import "./UserAccountTransfers.scss";
import { Box, CircularProgress, Typography } from "@mui/material";
import RegistrationSelect from "../../UI/Registration/RegistrationSelect";
import RegistrationInput from "../../UI/Registration/RegistrationInput";
import { getErrorMessage } from "../../../util/utilfunctions/utilFunctions";
import Contacts from "./Contacts";
import CustomAlert from "../../UI/CustomAlert/CustomAlert";
import InternationalTransferHistory from "./InternationalTransfers/InternationalTransferHistory";
import InternationalTransferFooterButtons from "./InternationalTransfers/InternationalTransferFooterButtons";
import PinPad from "../../PinPad/PinPad";
import { useSelector } from "react-redux";
import { bpiAPI, bpiGetBanks, bpiTrackTransaction } from "../../../util/API/bpi";
import { countryList } from "../../../constants/countrylist";
import InternationalTransferSummary from "./InternationalTransfers/InternationalTransferSummary";
import { findScrollableParent } from "../../../util/utilfunctions/utilFunctions";
import InternationalTransferTrack from "./InternationalTransfers/InternationalTransferTrack";

function BPI({ handleBack }) {
    const [page, setPage] = useState("init");
    const [contacts, setContacts] = useState(null);
    const [history, setHistory] = useState(null);
    const [formValues, setFormValues] = useState({});
    const [formErrors, setFormErrors] = useState({});
    const [alert, setAlert] = useState({});
    const [showPin, setShowPin] = useState(false);
    const [states, setStates] = useState([]);
    const [selectedContact, setSelectedContact] = useState(null);
    const [counties, setCountries] = useState([]);
    const [balance, setBalance] = useState(0);
    const [contactButtonText, setContactButtonText] = useState("Save contact");
    const [orderStatus, setOrderStatus] = useState('');
    const [bankList, setBankList] = useState([]);

    const [payoutMethod, setPayoutMethod] = useState([
        { value: "01", label: "Credit to BPI Account", key: "Credit to BPI Account" },
        { value: "06", label: "Cash PickUp in BPI Branch", key: "Cash PickUp in BPI Branch" },
        { value: "04", label: "Cash PickUp in Outlet", key: "Cash PickUp in Outlet" },
        { value: "04", label: "Cash Delivery", key: "Cash Delivery" },
        { value: "03", label: "Bank Account", key: "Bank Account" }
    ]);

    const [currencies, setCurrencies] = useState([
        { value: "USD", label: "USD", key: "USD" },
        { value: "PHP", label: "PHP", key: "PHP" },
    ]);

    const [zipPickup, setZipPickup] = useState([
        { value: "9777", label: "M. Lhuillier", key: "9777" },
        { value: "9888", label: "Cebuana Lhuillier", key: "9888" },
        { value: "9333", label: "Globe Banko", key: "9333" },
        { value: "9446", label: "Palawan Pawnshop", key: "9446" },
        { value: "9447", label: "Bayad Center", key: "9447" },
        { value: "9812", label: "LBC", key: "9812" },
        { value: "9911", label: "PeraHub", key: "9911" }
    ]);

    const editFormValues = (key, value) => {
        setFormValues((prev) => ({
            ...prev,
            [key]: value
        }))
    }

    const resendTransaction = async (item) => {
        let itemData = JSON.parse(item);
        console.log("resendTransaction======",itemData);
        let receiverName = itemData.receivername.split(" ");
        let middleName = '';
        let lastName = receiverName[1];
        if (receiverName.length === 3) {
            middleName = receiverName[1];
            lastName = receiverName[2];
        }
        setFormValues((prev) => ({
            ...prev,
            beneficiaryFirstName: receiverName[0],
            beneficiaryMiddleName: middleName,
            beneficiaryLastName: lastName,
            ...itemData
        }));
        setPage('shortform');
    }

    const saveContact = async () => {

        if (contacts && contacts.length) {
            for (let contact of contacts) {
                let contactInfo = contact.Usercontactlistexternal;
                let savedContactName = contactInfo.lastName; //firstname holds the service name
                savedContactName = savedContactName.replaceAll(/(\s)+/g, ' ');
                let newContactName = `${formValues.beneficiaryFirstName} ${formValues.beneficiaryMiddleName ? formValues.beneficiaryMiddleName + " ":""}${formValues.beneficiaryLastName}`;
                if (savedContactName.toLowerCase() === newContactName.toLowerCase()) {
                    setContactButtonText('Contact Already Exists');
                    return;
                }
            }
        }

        console.log("saveContact--------",formValues);

        const response = await bpiAPI(formValues, "createExternalContact");

        if (response.Status !== "1") {
            setContactButtonText("Could not save contact");
            return;
        }

        setContactButtonText("Contact Saved");
    }

    const sendToContact = (item) => {
        let contactOther = JSON.parse(selectedContact.Usercontactlistexternal.other.replaceAll(/&(amp;)*quot;/g, '"'));
        console.log("sendToContact======",formValues);
        console.log("sendToContact2======",contactOther);

        // let name = selectedContact.Usercontactlistexternal.lastName.split(" ");
        // let middleName = '';
        // let lastName = name[1];
        // if (name.length === 3) {
        //     middleName = name[1];
        //     lastName = name[2];
        // }
        setFormValues((prev) => ({
            ...prev,
            // beneficiaryFirstName: name[0],
            // beneficiaryMiddleName: middleName,
            // beneficiaryLastName: lastName,

            beneficiaryFirstName: selectedContact.Usercontactlistexternal.firstName,
            beneficiaryMiddleName: "",
            beneficiaryLastName: selectedContact.Usercontactlistexternal.lastName,
            
            beneficiaryCountry: contactOther.ctry,
            beneficiaryStateProvince: contactOther.state,
            beneficiaryCity: contactOther.city,
            beneficiaryAddress: contactOther.addr,
            beneficiaryBankAccountNo: contactOther.bAcct,
            beneficiaryBankCode: contactOther.bCode,
            beneZipcode: contactOther.zip,
            payoutmethod: contactOther.payout,
            receiverscurrency: contactOther?.receiverscurrency
        }));
        setPage('shortform');
    }

    const validateFinalForm = async() => {
        const fields = [
            'amount',
            'payoutmethod',
            'beneficiaryFirstName',
            'beneficiaryLastName',
            'beneficiaryCountry',
            'beneficiaryStateProvince',
            'beneficiaryCity',
            'beneficiaryAddress',
            'receiverscurrency'
        ];
        let errors = {};
        let errorCount = 0;
        let errorMessage = "";

        if(formValues?.amount == 0) {
            errors["ramount"] = true;
            errors["amount"] = true;
            errorCount++;
        }
        console.log("validateFinalForm1-----");

        console.log("validateFinalForm2-----", formValues);
        console.log("validateFinalForm2.5-----", formValues);
        for (let field of fields) {
            if (!formValues[field] || formValues[field]?.length === 0) {
                errors[field] = true;
                console.log("validateFinalForm2.7-----", field);
                console.log("validateFinalForm2.7-----", formValues[field]);
                errorCount++;
            }
        }
        console.log("validateFinalForm2.8-----", errorCount);

        if (formValues?.payoutmethodName === 'Cash PickUp in Outlet' || formValues?.payoutmethodName === 'Cash Delivery') {
            if (!formValues.beneZipcode || !formValues.beneZipcode.length || formValues.beneZipcode.length !== 4) {
                errorCount++;
                errors['beneZipcode'] = true;
                errorMessage += "ZIP code must be 4 digits.";
            }
        }
        if (formValues?.payoutmethodName === 'Credit to BPI Account') {
            if (!formValues.beneficiaryBankAccountNo || !formValues.beneficiaryBankAccountNo.length) {
                errorCount++;
                errors['beneficiaryBankAccountNo'] = true;
            }
        }
        console.log("validateFinalForm3-----", errorCount);
        if (formValues?.payoutmethodName === 'Bank Account') {
            if (!formValues.beneZipcode || !formValues.beneZipcode.length || formValues.beneZipcode.length !== 4) {
                errorCount++;
                errors['beneZipcode'] = true;
                errorMessage += "ZIP code must be 4 digits.";
            }
            if (!formValues.beneficiaryBankAccountNo || !formValues.beneficiaryBankAccountNo.length) {
                errorCount++;
                errors['beneficiaryBankAccountNo'] = true;
            }
            if (!formValues.beneficiaryBankCode || !formValues.beneficiaryBankCode.length) {
                errorCount++;
                errors['beneficiaryBankCode'] = true;
            }
        }
        console.log("validateFinalForm4-----", errorCount);

        if (errorCount > 0) {
            if (errorMessage.length > 0) {
                setAlertData(null, true, errorMessage, false);
            }
            setFormErrors(errors);
            return;
        } else {
            setFormErrors({});
        }

        console.log("errorCount-----",errorCount);
        console.log("errors-----",errors);

        const response = await bpiAPI(formValues, "calculateFees", "");
        if(response?.Status == "2") {
            setAlert({
                showAlert: true,
                severity: "error",
                message: response?.msg,
                header: "Error"
            });
            return;
        }

        const adminFees = response.adminFees;
        const transferFees = response.transferFees;
        const dfsst = response.taxes;
        const exchangeRate = parseFloat(response.exchangeRate);
        const receivingAmount = parseFloat(response.exchangeRate) * formValues?.amount;

        // const transferFees = response.adminFees;
        const taxes = 0.00;
        const totalAmount = parseFloat(formValues.amount) + parseFloat(adminFees) + parseFloat(transferFees) + parseFloat(dfsst?.taxamount);
        setFormValues((prev) => ({
            ...prev,
            adminFees: adminFees,
            transferFees: transferFees,
            taxes: dfsst?.taxamount,
            // taxes: taxes,
            totalAmount: totalAmount,
            recipientcurrencycode: formValues?.receiverscurrency,
            recipientamount: receivingAmount,
            exchangerate: exchangeRate
        }));

        setPage('summary');
    }

    const selectedUser = useSelector((state) => state.usersList.selectedUser);
    const selectedUserID = selectedUser.User.id;
    let agent = sessionStorage.getItem("user");
    agent = JSON.parse(agent);
    agent = agent.payload.body.User;

    //init data
    useEffect(() => {
        getInitData();
    }, []);

    useEffect(() => {
        if (page === 'init') {
            getInitData();
        }
    }, [page]);

    const containerRef = useRef();
    useEffect(() => {
        if (page === 'send' && containerRef.current) {
            const scrollable = findScrollableParent(containerRef.current);
            if (scrollable) scrollable.scrollTop = 0;
        }
    }, [page]);

    const getInitData = async () => {
        const isOperator = sessionStorage.getItem("isOperator");
        const parentuserid = sessionStorage.getItem("parentuserid");
        setFormValues((prev) => ({
            isOperator: isOperator,
            userid: selectedUserID,
            ...selectedUser.User,
            agentName: `${agent.firstName} ${agent.lastName}`,
            parentuserid: parentuserid,
            authUser: agent.id
        }));

        const response = await bpiAPI(formValues, "initData", { userid: selectedUserID });
        const banksListResponse = await bpiGetBanks();

        if(banksListResponse?.data?.header?.callStatus == "1") {
            console.log("banksListResponse============", banksListResponse?.data?.body);
            let bankListArr = banksListResponse?.data?.body;
            if (!Array.isArray(bankListArr)) {
                bankListArr = [bankListArr];
            }

            const formattedBanks = bankListArr.map(item => ({
                value: item?.Bpibanks?.bankid,
                label: item?.Bpibanks?.bankname,
                key: item?.Bpibanks?.id,
            }));

            setBankList(formattedBanks);
        }

        let history = response.history.body.record;
        if (!Array.isArray(history)) {
            history = [history];
        }
        let contacts = response.contacts.record;
        if (!Array.isArray(contacts)) {
            contacts = [contacts];
        }

        setHistory(history);
        setContacts(contacts);
        setCountries(response.countries);
        setBalance(response.balance);

        setPage('landing');
    }

    const handlePinConfirm = (event, pin) => {
        const userPin = pin.join('');
        sendMoney(userPin)
    }

    const sendMoney = async (pin) => {
        setPage('wait');
        setShowPin(false);
        const response = await bpiAPI(formValues, "sendMoney", {PIN: pin});
        console.log('BPI RESPONSE--------->>>>', response)
        if (response.Status !== '1') {
            setAlertData(response, true);
            return;
        }
        const transactionID = response.confirmcode;
        let payload = response.payload;
        let trngrpid = payload.trngrpid;
        setFormValues((prev) => ({
            ...prev,
            transactionID: transactionID,
            onhold: response?.onhold,
            onholdmsg: response?.onholdmsg,
            'trngrpid': trngrpid 
        }));
        setPage('receipt');
    }

        const setAlertData = (response, isError, message, goToLanding = true) => {
            if (isError) {
                let errorMessage
                if (response) {
                    errorMessage = getErrorMessage(response);
                }
                setAlert({
                    showAlert: true,
                    severity: "error",
                    message: errorMessage || message,
                    header: "Error"
                });
                if (goToLanding) {
                    setPage('init');
                }
               
            }
        }

    const getStates = async (countryCode) => {
        const response = await bpiAPI({ beneficiaryCountry: countryCode }, "getStates");

        let states = response.payload;
        if (!Array.isArray(states)) {
            states = [states];
        }

        const mappedArray = states.map(item => ({
            value: item.state_code,
            label: item.name,
            key: item.id
        }));

        setStates(mappedArray);
    }

        useEffect(() => {
            setPage('contact');
        }, [selectedContact])

    const getContactInformation = () => {
        if (!selectedContact) return;
        const data = selectedContact.Usercontactlistexternal;
        let otherdata = {};
        try {
            otherdata = JSON.parse(data.other.replaceAll(/&(amp;)*quot;/g, '"'));
        } catch (error) {

        }
        // let name = selectedContact.Usercontactlistexternal.lastName.split(" ");
        // let middleName = '';
        // let lastName = name[1];
        // if (name.length === 3) {
        //     middleName = name[1];
        //     lastName = name[2];
        // }
        return (
            <Box>
                <Box>Name: {selectedContact.Usercontactlistexternal.firstName} {selectedContact.Usercontactlistexternal.lastName}</Box>
                <Box>Address: {otherdata.addr}, {otherdata.city}, {otherdata.state}, {otherdata.ctry}</Box>
            </Box>);
    }

    const trackTransaction = async(refNumber, data) => {
        data = JSON.parse(data);
        console.log("trackTransaction_refNumber=========",refNumber);
        console.log("trackTransaction_data=========",data);
        const response = await bpiTrackTransaction(refNumber);
        console.log("trackTransaction_response=========",response);

        if (response.Status !== '1') {
            const msg = response?.payload?.msg
            if (msg === 'order not found'){
                setOrderStatus('UNCOMMITTED');
            }
            setPage("track");
            return;
        }

        let errorMessage = "Failed to track transaction.";

        const envelope = response?.payload?.body?.Envelope;
        const parsedData = envelope?.["soapenv:Body"]["oif:inqRemitStatusResponse"]["inq:RemitStatusResponseObject"];
        const statusCode = parsedData?.["inq:statusCode"];

        console.log("parsedData=========",parsedData);
        console.log("statusCode=========",statusCode);

        if (statusCode === "10") {
            setOrderStatus('AVAIL');
        } else if (statusCode === "11") {
            setOrderStatus('RECVD');
        } else if (statusCode.match(/refund/gi) || statusCode === 'REFND') {
            setOrderStatus('REFND');
        } else if (statusCode === "12") {
            setOrderStatus('CANCL');
        } else if (["1","3","7","11","13","14","15","16","18","20","21","23","9","10"].includes(statusCode)) {
            setOrderStatus('HOLD');
        } else if (statusCode === "15") {
            setOrderStatus('PRCSS');
        }  else if (["8", "17", "19", "34", "35"].includes(statusCode)) {
            setOrderStatus('PROCSD');
        } else {
            setOrderStatus('PRCSS');
        }

        setPage("track");
    }

    return (
        <Box className="container">
            <Box className="pageContainer" sx={{ width: "100%", margin: 'auto' }}>
                <Typography
                    sx={{
                        fontFamily: "'Nunito'",
                        fontStyle: "normal",
                        fontWeight: 500,
                        fontSize: "21.4825px",
                        color: "#3A3A3A",
                    }} className="text-center">International Transfer - BPI</Typography>
                {page === 'landing' ?
                    <Box>
                        <Box className="contactContainer">
                            <Box className="d-flex justify-content-between">
                                <Box className="lh-lg fw-bold">Contacts</Box>
                            </Box>
                            <Contacts
                                contacts={contacts}
                                service={"BPI"}
                                setSelectedContact={setSelectedContact} />
                        </Box>
                        <Box className="historyContainer mt-3">
                            <Box className="fw-bold">Recent History</Box>
                            <InternationalTransferHistory
                                history={history}
                                service={"BPI"}
                                trackTransaction={(refNumber, data) => trackTransaction(refNumber, data)}
                                handleResend={(item) => resendTransaction(item)}
                            />
                        </Box>
                        <InternationalTransferFooterButtons
                            handleButtonOne={handleBack}
                            handleButtonTwo={() => setPage('receive')}
                            handleMiddleButton={() => setPage('send')}
                            buttonOneText="Return"
                            buttonTwoText="Receive Money"
                            middleButtonText="Send Money To New Contact"
                            showMiddleButton={true}
                            showButtonTwo={false}
                        />

                    </Box> : ''}
                {page === 'send' ?
                    <Box
                        sx={{
                            maxHeight: "600px",
                            marginTop: "10px"
                        }}
                        ref={containerRef}>
                        
                        <RegistrationInput
                            label="Amount"
                            required={true}
                            onChange={(e) => editFormValues('amount', e.target.value)}
                            value={formValues.amount}
                            hasError={formErrors.amount} />
                        <RegistrationSelect
                            label="Payout Method"
                            options={payoutMethod}
                            required={true}
                            onChange={(e) => { editFormValues('payoutmethod', e.target.value); editFormValues('payoutmethodName', e.target.key); }}
                            value={formValues.payoutmethod}
                            hasError={formErrors.payoutmethod} />
                        <RegistrationInput
                            label="Receiver First Name"
                            required={true}
                            onChange={(e) => editFormValues('beneficiaryFirstName', e.target.value)}
                            value={formValues.beneficiaryFirstName}
                            hasError={formErrors.beneficiaryFirstName} />
                        <RegistrationInput
                            label="Receiver Middle Name"
                            required={true}
                            onChange={(e) => editFormValues('beneficiaryMiddleName', e.target.value)}
                            value={formValues.beneficiaryMiddleName}
                            hasError={formErrors.beneficiaryMiddleName} />
                        <RegistrationInput
                            label="Receiver Last Name"
                            required={true}
                            onChange={(e) => editFormValues('beneficiaryLastName', e.target.value)}
                            value={formValues.beneficiaryLastName}
                            hasError={formErrors.beneficiaryLastName} />
                        <RegistrationSelect
                            label="Receiver's Nationality"
                            options={countryList ?? []}
                            required={true}
                            onChange={(e) => { editFormValues('beneficiaryCountry', e.target.value); getStates(e.target.value) }}
                            value={formValues.beneficiaryCountry}
                            hasError={formErrors.beneficiaryCountry} />
                        <RegistrationSelect
                            label="Receiver's State of Nationality"
                            options={states ?? []}
                            required={true}
                            onChange={(e) => editFormValues('beneficiaryStateProvince', e.target.value)}
                            value={formValues.beneficiaryStateProvince}
                            hasError={formErrors.beneficiaryStateProvince} />
                        <RegistrationInput
                            label="Receiver's City"
                            required={true}
                            onChange={(e) => editFormValues('beneficiaryCity', e.target.value)}
                            value={formValues.beneficiaryCity}
                            hasError={formErrors.beneficiaryCity} />
                        <RegistrationInput
                            label="Receiver's Address"
                            required={true}
                            onChange={(e) => editFormValues('beneficiaryAddress', e.target.value)}
                            value={formValues.beneficiaryAddress}
                            hasError={formErrors.beneficiaryAddress} />
                        <RegistrationSelect
                            label="Receiver's Currency"
                            options={currencies}
                            required={true}
                            onChange={(e) => { editFormValues('receiverscurrency', e.target.value); }}
                            value={formValues.receiverscurrency}
                            hasError={formErrors.receiverscurrency} />
                        {(formValues.payoutmethodName === 'Cash Delivery' || formValues.payoutmethodName === 'Bank Account') &&
                            <RegistrationInput
                                label="Receiver's ZipCode / Postal Code"
                                required={true}
                                onChange={(e) => editFormValues('beneZipcode', e.target.value)}
                                value={formValues.beneZipcode}
                                hasError={formErrors.beneZipcode} />}
                        {formValues.payoutmethodName === 'Cash PickUp in Outlet' &&
                            <RegistrationSelect
                                label="Pickup Location"
                                options={zipPickup ?? []}
                                required={true}
                                onChange={(e) => editFormValues('beneZipcode', e.target.value)}
                                value={formValues.beneZipcode}
                                hasError={formErrors.beneZipcode} />}
                        {/* {formValues.payoutmethodName === 'Bank Account'
                            &&
                            <RegistrationInput
                                label="Receiver's Bank Code"
                                required={true}
                                onChange={(e) => editFormValues('beneficiaryBankCode', e.target.value)}
                                value={formValues.beneficiaryBankCode}
                                hasError={formErrors.beneficiaryBankCode} />} */}
                        {formValues.payoutmethodName === 'Bank Account'
                            &&
                            <RegistrationSelect
                                label="Select Bank"
                                options={bankList}
                                required={true}
                                onChange={(e) => { 
                                    console.log("Select Bank onChange===========", e.target.value);
                                    editFormValues('beneficiaryBankCode', e.target.value); 
                                }}
                                value={formValues.beneficiaryBankCode}
                                hasError={formErrors.beneficiaryBankCode} />
                        }
                        {(formValues.payoutmethodName === 'Credit to BPI Account' || formValues.payoutmethodName === 'Bank Account')
                            &&
                            <RegistrationInput
                                label="Receiver's Bank Account Number"
                                required={true}
                                onChange={(e) => editFormValues('beneficiaryBankAccountNo', e.target.value)}
                                value={formValues.beneficiaryBankAccountNo}
                                hasError={formErrors.beneficiaryBankAccountNo} />
                        }
                        <InternationalTransferFooterButtons
                            handleButtonOne={() => setPage('init')}
                            handleButtonTwo={() => validateFinalForm()}
                            buttonOneText="Back"
                            buttonTwoText="Continue"
                        />
                    </Box> : ''}
                {
                    page === 'summary' ?
                        <Box
                            sx={{
                                maxHeight: "600px",
                                marginTop: "10px"
                            }}>

                            <InternationalTransferSummary
                                transferDetails={formValues}
                                type="send"
                                handleReturn={() => setPage('init')}
                                service="BPI"
                                user={selectedUser}
                                handleContinue={() => setShowPin(true)}
                                handleSaveContact={saveContact}
                                contactButtonText={contactButtonText}
                            />
                        </Box>
                        : ""
                }

                {
                    page === 'receipt' ?
                        <Box
                            sx={{
                                maxHeight: "600px",
                                marginTop: "10px"
                            }}>

                            <InternationalTransferSummary
                                type="receive"
                                transferDetails={formValues}
                                handleReturn={() => setPage("init")}
                                user={selectedUser}
                                handleContinue={() => setPage("init")}
                                isReceipt={true}
                                service={"BPI"}
                            />
                        </Box>
                        : ""
                }

                {
                    page === 'wait' || page === 'init' ?
                        <Box sx={{
                            maxHeight: "600px",
                            marginTop: "10px"
                        }}>
                            <Box
                                className="mt-5 d-flex justify-content-center align-items-center">
                                <CircularProgress
                                    size="10rem" />
                            </Box>
                        </Box>
                        : ''
                }

                {page === 'shortform' ?

                    <Box sx={{
                        maxHeight: "600px",
                        marginTop: "10px"
                    }}>
                        <RegistrationInput
                            label="Amount"
                            type="number"
                            onChange={(e) => editFormValues('amount', e.target.value)}
                            value={formValues.ramount ? formValues.ramount : formValues.amount}
                            hasError={formErrors.ramount ? formErrors.ramount : formErrors.amount} />
                        <InternationalTransferFooterButtons
                            handleButtonOne={() => setPage('init')}
                            handleButtonTwo={() => validateFinalForm()}
                            buttonOneText="Return"
                            buttonTwoText="Continue"
                        />
                    </Box>
                    : ''
                }

                {page === 'contact' ?
                    <Box sx={{
                        maxHeight: "600px",
                        marginTop: "10px"
                    }}>
                        {getContactInformation()}

                        <InternationalTransferFooterButtons
                            handleButtonOne={() => setPage('init')}
                            handleButtonTwo={() => sendToContact()}
                            buttonOneText="Cancel"
                            buttonTwoText="Send To This Contact"
                        />
                    </Box>
                    : ''
                }

                {
                    page === 'track' &&
                    <InternationalTransferTrack 
                        transactionStatus={orderStatus}
                        handleReturn={() => setPage('init')}
                        isCancellable={false}
                    />
                }
                {showPin && <PinPad show={showPin} handleConfirm={handlePinConfirm} onClick={() => setShowPin(false)} />}
            </Box>
            <CustomAlert severity={alert.severity} show={alert.showAlert} header={alert.header} message={alert.message} onClick={(prev) => setAlert({ ...prev, showAlert: false })} autoclose={alert.severity === "error" ? false : true} />
        </Box>
    );
}

export default BPI;
